/**
 * Created by portiz on 8/24/2018.
 */
import React from 'react';
import { Media } from 'reactstrap';

/**
 * The loading icon
 */
class LoadingIcon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: true
        };

        this.toggle = this.toggle.bind(this);
    }

    /**
     * Hide or shows the icon
     */
    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {
        return (
              <Media src={require('../../svg/loader.svg')} alt="Loader"/>
        );
    }
}

export default LoadingIcon;


// WEBPACK FOOTER //
// ./src/components/loader-windows/loading-icon.js